import script from "./AppSlippageForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSlippageForm.vue?vue&type=script&setup=true&lang=ts"

import "./AppSlippageForm.vue?vue&type=style&index=0&id=7755021e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7755021e"]])

export default __exports__